import api from './index';

export interface AdminUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  discordUsername?: string;
}

export async function fetchAdminUsers(): Promise<AdminUser[]> {
  const response = await api.get<{ users: AdminUser[] }>('/admin/users');
  return response.data.users;
}

export async function searchAdminUsers(query: string, limit?: number): Promise<AdminUser[]> {
  const params: { q: string; limit?: number } = { q: query };
  if (limit != null) params.limit = limit;
  const response = await api.get<{ users: AdminUser[] }>('/admin/users/search', {
    params
  });
  return response.data.users;
}

const INITIAL_PREFILL_LIMIT = 20;

export async function fetchInitialAdminUsers(): Promise<AdminUser[]> {
  return searchAdminUsers('', INITIAL_PREFILL_LIMIT);
}
